var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinimize(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Slice 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(6.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 L6.17699843,1.59477862 L1.49127215,5.69389527 L0.86016898,6.24599016 C0.444493055,6.6096273 0.402307285,7.24138536 0.765944426,7.65706129 C0.795175245,7.69047522 0.826598745,7.72190551 0.860006363,7.75114355 L8,14 L8,14",
    id: "Fill-1",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0140527,7 C17.0140527,6.44771525 16.5663374,6 16.0140527,6 L2,6 C1.44771525,6 1,6.44771525 1,7 C1,7.55228475 1.44771525,8 2,8 L16.0140527,8 C16.5663374,8 17.0140527,7.55228475 17.0140527,7 Z",
    id: "Briefcase-path-Copy-6",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/minimize.3796ecd9.svg";
export { ForwardRef as ReactComponent };